import { render } from "./MapMarkerOff.vue?vue&type=template&id=48215008"
import script from "./MapMarkerOff.vue?vue&type=script&lang=js"
export * from "./MapMarkerOff.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__